import React from 'react';
import { motion } from 'framer-motion';

const galleryImages = [
  {
    url: 'https://images.unsplash.com/photo-1703514785560-36bfec8cebfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
    alt: 'Traditional Kerala bride in kasavu saree',
    span: 'md:col-span-2 md:row-span-2'
  },
  {
    url: 'https://images.unsplash.com/photo-1641666017446-50076092374e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    alt: 'Brass lamps and jasmine decoration',
    span: 'md:col-span-1 md:row-span-1'
  },
  {
    url: 'https://images.unsplash.com/photo-1696965663086-7e632299ce0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    alt: 'Traditional sadya feast on banana leaf',
    span: 'md:col-span-1 md:row-span-1'
  },
  {
    url: 'https://images.unsplash.com/photo-1699163104435-4a1d618043b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    alt: 'Chenda melam performance',
    span: 'md:col-span-1 md:row-span-2'
  },
  {
    url: 'https://images.pexels.com/photos/14132112/pexels-photo-14132112.jpeg?auto=compress&cs=tinysrgb&w=600',
    alt: 'Overhead shot of Kerala sadya',
    span: 'md:col-span-2 md:row-span-1'
  },
  {
    url: 'https://images.unsplash.com/photo-1558247102-3cd1995b1e6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
    alt: 'Traditional Kerala drums',
    span: 'md:col-span-1 md:row-span-1'
  }
];

const GallerySection = () => {
  return (
    <section className="py-24 md:py-32 px-6 bg-stone-50" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4" data-testid="gallery-title">
            Memories in the Making
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {galleryImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative overflow-hidden rounded-xl md:rounded-3xl hover-scale cursor-pointer ${image.span}`}
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover min-h-[200px]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-emerald-900/0 hover:bg-emerald-900/20 transition-colors duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;